<template>
  <footer class="company-footer">
    <div class="company-footer__name">STARSALIGN TECH LIMITED</div>
    <div v-if="showAddress" class="company-footer__address">
      RM 1307, 13/F., KENBO COMMERCIAL BUILDING, 335-339 QUEEN'S ROAD WEST, HONG KONG
    </div>
  </footer>
</template>

<script>
export default {
  name: "CompanyFooter",
  props: {
    showAddress: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.company-footer {
  padding: 24px 28px 140px;
  color: #7a7d85;
  font-size: 22px;
  line-height: 1.5;
  text-align: center;
  background: #fff;
}

.company-footer__name {
  color: #4a4a4a;
  font-weight: 600;
}

.company-footer__address {
  margin-top: 8px;
}

</style>
